import { LineMessageAction } from '../actions/lineMessage'

const initialState: Props = {
  message: '',
  snackOpen: false,
}

interface Props {
  message: string
  snackOpen: boolean
}

const reducer = (
  state: Props = initialState,
  action: LineMessageAction,
): Props => {
  switch (action.type) {
    case 'INIT_LINE_MESSAGE': {
      const { line_message: message } = action.client
      return {
        ...state,
        message,
      }
    }
    case 'COMPLETE_UPLOAD_LINE_MESSAGE': {
      return {
        ...state,
        snackOpen: true,
      }
    }
    case 'CLOSE_LINE_MESSAGE_SNACK': {
      return {
        ...state,
        snackOpen: false,
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
